import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * SEOHelmet – drop-in per-page SEO tags.
 *
 * Usage:
 *   <SEOHelmet
 *     title="NIN Verification | e-citizen"
 *     description="Instantly verify any Nigerian NIN…"
 *     canonical="https://e-citizen.ng/nin-verification"
 *     ogImage="https://e-citizen.ng/og-nin.png"
 *   />
 */
const BASE_URL = "https://e-citizen.ng";
const DEFAULT_OG_IMAGE = `${BASE_URL}/og-image.png`;

const SEOHelmet = ({
  title = "e-citizen | NIN, BVN, Business & Vehicle Verification Nigeria",
  description = "Nigeria's #1 identity verification platform. Instantly verify NIN, BVN, phone numbers, CAC business registration, credit profiles, and vehicle history.",
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  keywords,
  noIndex = false,
  structuredData,
}) => {
  const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : BASE_URL;

  return (
    <Helmet>
      {/* Primary */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="e-citizen" />
      <meta property="og:locale" content="en_NG" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD structured data (optional, page-specific) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHelmet;

